import { ConnectOptions } from 'twilio-video';

export const getConnectOptions = (
  localTracks: ConnectOptions['tracks'],
): ConnectOptions => ({
  tracks: localTracks,
  preferredVideoCodecs: [{ codec: 'VP8', simulcast: true }, { codec: 'H264' }],
  preferredAudioCodecs: [{ codec: 'opus', dtx: false }],
  networkQuality: {
    local: 1,
    remote: 2,
  },
  bandwidthProfile: {
    video: {
      mode: 'collaboration',
      maxSubscriptionBitrate: 2500000,
      dominantSpeakerPriority: 'high',
      renderDimensions: {
        high: { width: 1280, height: 720 },
        standard: { width: 640, height: 480 },
        low: { width: 320, height: 240 },
      },
    },
  },

  maxAudioBitrate: 16000,
});
